export var MatchmakingMatchTypes = /*#__PURE__*/ function(MatchmakingMatchTypes) {
    MatchmakingMatchTypes[MatchmakingMatchTypes["RankedClassic4P"] = 1] = "RankedClassic4P";
    MatchmakingMatchTypes[MatchmakingMatchTypes["UnrankedClassic4P"] = 2] = "UnrankedClassic4P";
    MatchmakingMatchTypes[MatchmakingMatchTypes["RankedCitiesAndKnights4P"] = 9] = "RankedCitiesAndKnights4P";
    MatchmakingMatchTypes[MatchmakingMatchTypes["UnrankedClassic1v1"] = 13] = "UnrankedClassic1v1";
    MatchmakingMatchTypes[MatchmakingMatchTypes["RankedClassic1v1"] = 15] = "RankedClassic1v1";
    MatchmakingMatchTypes[MatchmakingMatchTypes["UnrankedShuffle"] = 16] = "UnrankedShuffle";
    MatchmakingMatchTypes[MatchmakingMatchTypes["RankedRush4P"] = 17] = "RankedRush4P";
    return MatchmakingMatchTypes;
}({});
export var BotsMatchType = /*#__PURE__*/ function(BotsMatchType) {
    BotsMatchType["BeginnerMode"] = "beginner-mode";
    BotsMatchType["Easy"] = "bots-easy";
    BotsMatchType["Medium"] = "bots-medium";
    BotsMatchType["Hard"] = "bots-hard";
    BotsMatchType["ColonistRush"] = "bots-colonist-rush";
    return BotsMatchType;
}({});
export function isBotMatchType(matchType) {
    return Object.values(BotsMatchType).includes(matchType);
}
const BOT_DIFFICULTY_MATCH_TYPES = [
    "bots-easy",
    "bots-medium",
    "bots-hard"
];
export function isBotDifficultyMatchType(matchType) {
    return BOT_DIFFICULTY_MATCH_TYPES.includes(matchType);
}
export const MODE_BASE_PLAYTIME_MINUTES = {
    CLASSIC: 25,
    CITIES_AND_KNIGHTS: 40,
    SEAFARERS: 25,
    CITIES_AND_KNIGHTS_SEAFARERS: 40,
    COLONIST_RUSH: 10,
    CLASSIC_1V1: 10,
    BOTS_BEGINNER_MODE: 5,
    BOTS_STANDARD: 10,
    BOTS_COLONIST_RUSH: 10
};
